<template>
    <div id="quicklyAddMansion">
      <a-form :form="mansionVO" layout="vertical">
        <a-row :gutter="20">
          <a-col :span="8">
            <a-form-item class="required" :label="$t('mansion.addMansion.formLabel.mansionName')"
            >
              <ptInput :disabled="mansionId != null" v-decorator="['name',{rules: [
                {required: true,message: $t('mansion.addMansion.formLabel.mansionName'),},
                {min: 1, max: 64, message: $t('mansion.addMansion.form.errorTip.textMinLength'), trigger: 'blur'},
              ],}]" :placeholder="$t('mansion.addMansion.placeholder.mansionName')"></ptInput>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="required" :label="$t('mansion.addMansion.formLabel.mansionType')"
            >
              <pt-select v-decorator="['mansionType',{rules: [
                {required: true,message: $t('mansion.addMansion.placeholder.mansionType'),}
              ],}]" :placeholder="$t('mansion.addMansion.placeholder.mansionType')">
                <a-select-option v-for="(mansionType,index) in mansionSetupMap.mansionTypeList":key="index" :value="mansionType.wordKey">{{mansionType.wordValue}}</a-select-option>
              </pt-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item class="required" :label="$t('mansion.mansionView.mansionBaseCollapseHeader.mansionfloor.floorNum')"
            >
              <pt-input-number v-decorator="['totalFloor',{rules:[
                         {required: true,message:$t('mansion.addMansion.placeholder.mansionfloor.floorNum'),}
                        ]}]"  :min="1" :max="999" :precision="0" style="width: 100%"
                               :placeholder="$t('mansion.addMansion.placeholder.mansionfloor.floorNum')" ></pt-input-number>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row  :gutter="20">
          <a-col :span="6" v-show="false">
            <a-form-item  :label="$t('mansion.addMansion.formLabel.regionStr')">
              <pt-input v-decorator="['region']"></pt-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('mansion.addMansion.formLabel.regionStr')" class="required">
              <pt-cascader
                v-decorator="['regionStr',{rules: [
                {required: true,message: $t('mansion.addMansion.placeholder.regionStr'),}
              ],}]"
                :cityDatas="cityDatas" change-on-select :placeholder="$t('mansion.addMansion.placeholder.regionStr')" @changeValue="changeRegion" ></pt-cascader>
            </a-form-item>
          </a-col>
          <a-col :span="16">
            <a-form-item class="required" :label="$t('mansion.addMansion.formLabel.address')"
            >
              <ptInput class="address_left_6" style="padding: 0px !important;" v-decorator="['address',{rules: [
                {required: true,message: $t('mansion.addMansion.placeholder.address'),}
              ],}]" :placeholder="$t('mansion.addMansion.placeholder.address')"  >
                <span slot="suffix" style="font-size: 12px;color: #999999;cursor: pointer"  @click="openMap"><a-icon  type="environment" style="padding-right:5px;color: rgba(0, 0, 0, 0.25);"></a-icon>{{ $t('keydingwei') }}</span>
              </ptInput>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <pt-modal :footer="true" :title="$t('mansion.mapSearch.title')" :width="1000" :visible="mapModel.visible" @cancel="closeMap">
        <div  slot="content" class="amap-page-container">
          <pt-map  :center="curCity" :style="mapStyle" @getClickInfo="getClickInfo" :zoom="zoom" :keyword="keyword"></pt-map>
<!--          <baidu-map ref="ptMap" v-bind:style="mapStyle" class="bm-view" :center="curCity" :zoom="zoom" :scroll-wheel-zoom="true" @ready="handler"-->
<!--                     @click="getClickInfo" @moving="syncCenterAndZoom" @moveend="syncCenterAndZoom" @zoomend="syncCenterAndZoom">-->
<!--            <bm-view style="width: 100%; height:500px;"></bm-view>-->
<!--            <bm-marker  :dragging="true" animation="BMAP_ANIMATION_BOUNCE">-->
<!--            </bm-marker>-->
<!--            <bm-control :offset="{width: '10px', height: '10px'}">-->
<!--              <bm-auto-complete @confirm="confirm" v-model="keyword" :sugStyle="{zIndex: completeIndex}">-->
<!--                <input ref="mapInput"  v-model="keyword" type="text" :placeholder="$t('mansion.mapSearch.placeholder')" class="serachinput">-->
<!--              </bm-auto-complete>-->
<!--            </bm-control>-->
<!--            <bm-local-search :pageCapacity="pageCapacity"-->
<!--                             :panel="panel" :location="companyCity" :forceLocal="false" :keyword="keyword" :auto-viewport="true" class="searchResult"></bm-local-search>-->
<!--          </baidu-map>-->
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import CompanyApi from '@/api/sys/organization'
  import { mapState } from 'vuex'
  import {saveMansion,getMansionData} from '@/api/database/mansion'
  import {findCascadingData,findDataByCity,getDatadictChildsByPath} from '@/api/sys/datadict';
  export default {
    name: 'quicklyAddMansion',
    props:{
      cityValue:{
        type:String,
        default:null,
      }
    },
    data(){
      return{
        completeIndex:999999,
        companyInfo:{},//公司信息
        mansionId:null,//大厦id,
        mapModel:{
          visible:false,
        },
        mapStyle: {
          width: '100%',
          height: this.mapHeight + 'px'
        },
        curCity:'深圳',
        zoom: 15,
        keyword: '',
        pageCapacity:5,
        center: {
          lng: 113.952925,
          lat: 22.541696
        },
        panelTrue:false,
        panel:false,
        companyCity:"深圳市",//城市信息
        mansionVO:this.$form.createForm(this),
        mansionSetupMap:{},//楼宇的数据库字典设置
        addresslat:null,
        addresslng:null,
        city:"",//楼宇城市信息
        province:"",//省份信息
        cityDatas:[]
      }
    },
    mounted(){
      this.getMansionDataStep();//查询楼宇设置
      this.init();
    },
    beforeCreate () {
      this.mansionVO = this.$form.createForm(this);
    },
    computed:{
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods:{
      init(){
        this.queryCompanyById();
        this.queryCityDataByCity();
        this.initCityMap();
      },
      queryCityDataByCity(){//根据城市查询区域位置
        let this_ = this
        findCascadingData("system.mansion_set.address",4,this.cityValue).then(res=>{
          this_.cityDatas = res.data
        })
      },
      changeRegion(value){
        console.log(value)
        // if(value != null && value.length < 3){
        //   if(value.length == 1){
        //     value.push("other");
        //     value.push("other");
        //   }else if(value.length == 2){
        //     value.push("other");
        //   }
        // }
        if(this.cityValue == '香港'){
          this.city = 'hk'
          this.province = 'hk'
        }else{
          this.city = value[0] == 'hk'?value[0]:(value[1]+"").toUpperCase();
          this.province = value[0]
        }

        //设置区域
        this.mansionVO.setFieldsValue({
          region: value.toString(),
          regionStr: value
        })
      },
      queryCompanyById(){
        CompanyApi.selectDepByCompanyId(this.userInfo.employeeDO.companyId).then(res=>{
          if(res.code == 1){
            this.companyInfo = res.data[0];
          }
        })
      },
      getMansionDataStep(){
        let this_ = this
        getMansionData().then(res=>{
          if(res.code == 1){
            this_.mansionSetupMap = res.data
          }
        })
      },
      submit(){
        this.mansionVO.validateFields(err=>{
          if(!err){
            let submitData = this.mansionVO.getFieldsValue();
            if(this.city){
              submitData["cityStr"] = this.city;
            }
            if(this.province){
              submitData["provinceStr"] = this.province;
            }
            if(this.addresslat && this.addresslng){ //保存楼宇经度纬度数据
              submitData["addresslat"] = this.addresslat;
              submitData["addresslng"] = this.addresslng;
            }
            console.log(submitData);
            this.saveMansionData(submitData);
          }else{
            this.$emit('error')
          }
        })
      },
      saveMansionData(data){
        saveMansion(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('mansion.addMansion.saveSuccess'));
            this.$emit('saveSuccess',res.data.id,res.data.name);
          }else{
            this.$emit('error')
          }
        }).catch(()=>{
          this.$emit('error')
        })
      },
      handler ({ BMap, map }) {
        setTimeout(()=>{
          if(this.mansionVO.getFieldValue("name") != null && this.mansionVO.getFieldValue("name") != undefined){
            this.keyword = this.mansionVO.getFieldValue("name");
          }
          this.$refs.mapInput.value = this.keyword;
          this.completeIndex = -99;
          map.centerAndZoom(this.companyCity,13)
        },1)
      },
      openMap(){
        this.companyCity = this.companyInfo.cityName;
        this.mapModel.visible = true;
        if(this.mansionVO.getFieldValue("name") != null && this.mansionVO.getFieldValue("name") != undefined){
          this.keyword = this.mansionVO.getFieldValue("name");
        }
        this.$refs.ptMap.map.centerAndZoom(this.companyCity,13)
      },
      closeMap(){
        this.mapModel.visible = false;
      },
      initCityMap(){
        this.curCity = this.$store.getters.userInfo.companyDO.cityName;
      },
      getClickInfo (e) {
        this.center.lng = e.point.lng
        this.center.lat = e.point.lat
        this.queryAdderss(e);
      },
      queryAdderss(e){ //获取详细地址
        let lat = e.point.lat;
        let lng = e.point.lng;

        this.addresslat = lat;
        this.addresslng = lng;
        this.mansionVO.setFieldsValue({
          address: e.address
        })
        this.mapModel.visible = false;

      },
      syncCenterAndZoom (e) {

      },
      confirm(type,target,item){
        this.completeIndex = -99;
        this.companyCity = type.item.value.city;
      },
    }
  }
</script>

<style scoped lang="less">
  #quicklyAddMansion{
    background: rgba(248,249,251,0.62);
    border-radius: 0 0 4px 4px;
    padding: 30px 20px 10px 20px;
  }
  .amap-demo {
    height: 400px;
  }
  .search-box {
    position: absolute;
  }
  .amap-page-container {
    position: relative;
    margin: -30px -20px;
  }
  .searchResult{
    /*position: absolute;*/
    /*top: 35px;*/
    /*left: 0;*/
    /*width: 300px;*/
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .address_left_6 /deep/  .ant-input[type='text']{
      padding-left: 6px !important;
  }

  .serachinput {
    width: 300px;
    box-sizing: border-box;
    padding: 9px;
    border: 1px solid #dddee1;
    line-height: 20px;
    font-size: 16px;
    height: 38px;
    color: #333;
    position: relative;
    border-radius: 4px;
    -webkit-box-shadow: #666 0px 0px 10px;
    -moz-box-shadow: #666 0px 0px 10px;
    box-shadow: #666 0px 0px 10px;
  }
</style>